import { render, staticRenderFns } from "./GuideLanding.vue?vue&type=template&id=8c54989e&scoped=true"
import script from "./GuideLanding.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideLanding.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GuideLanding.vue?vue&type=style&index=0&id=8c54989e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c54989e",
  null
  
)

export default component.exports